<div *ngIf="spinnerState$ | async" class="loader-overlay">
  <div class="loader">{{spinnerTitle}}</div>
</div>
